import React from "react";
import "./CSS/Styled.css";
import { Link } from "react-router-dom";

import img1 from "./IMAGES/Rectangle 929.png";
import img2 from "./IMAGES/Rectangle 930.png";
import img3 from "./IMAGES/Rectangle 931.png";
import img4 from "./IMAGES/Rectangle 932.png";
import img5 from "./IMAGES/Rectangle 933.png";
import img6 from "./IMAGES/Rectangle 934.png";
import img7 from "./IMAGES/Rectangle 935.png";
import img8 from "./IMAGES/Rectangle 936.png";

const images = [
  img1, img2, img3, img4,
  img5, img6, img7, img8
];

const StyledBy = () => {
  return (
    <div className="styled-container">
      
      {/* Header */}
      <div className="styled-header">
        <h1>Styled By SaPra</h1>
<Link to="/shop" className="see-alls">
  See all
</Link>                </div>

        <p className="subtitlea">
          See How Our Beautiful Customers Styled Our Collection <br />
          For Their Weddings, Festivals, And Special Moments.
        </p>
      

<div className="styled-grid">

  {/* Row 1 */}
  <div className="styled-track">
    {[...images.slice(0, 4), ...images.slice(0, 4)].map((img, i) => (
      <div className="styled-card" key={i}>
        <img src={img} alt="" />
      </div>
    ))}
  </div>

  {/* Row 2 */}
  <div className="styled-track reverse">
    {[...images.slice(4, 8), ...images.slice(4, 8)].map((img, i) => (
      <div className="styled-card" key={i}>
        <img src={img} alt="" />
      </div>
    ))}
  </div>

</div>

    </div>
  );
};

export default StyledBy;